import { useState, useEffect } from "react";
import DocCommentDetails from "./DocCommentDetails";
import { useNavigate } from "react-router-dom";
const DocumentComments = () => {
  const [documentId, setDocumentId] = useState("");
  const [caseId, setCaseId] = useState("");
  const [commentOn, setCommentOn] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setDocumentId(params.get("documentId"));
    setCaseId(params.get("caseId"));
    setCommentOn(params.get("commentOn"));
  }, []);
  return (
    <div>
      <div
        style={{ color: "rgba(0,0,0,0.5)" }}
        className="text-[11px] 2xl:text-sm leading-[18.27px] -tracking-[3%] cursor-pointer"
      >
        <span onClick={() => navigate("/")}>Home</span> /{" "}
        <span onClick={() => navigate(`/dashboard/case-status`)}>
          Case Status
        </span>{" "}
        /{" "}
        <span onClick={() => navigate(`/dashboard/case-status/${caseId}`)}>
          Case Details
        </span>{" "}
        / Document Comments
      </div>
      {/* <div className="w-fit text-[30px] 2xl:text-[50px] leading-[65.26px] -tracking-[7%]  mt-[12px] 2xl:mt-[30px]">
        Document Comments
      </div> */}
      {documentId && (
        <DocCommentDetails documentId={documentId} commentOn={commentOn} />
      )}
    </div>
  );
};

export default DocumentComments;
